import { VueSlideToggle } from "vue-slide-toggle";
import menuItemLabel from "@/components/misc/menu-item-label.vue";
import {
  isClickableInDropdown,
  isClickableInSidebarMenu,
  isMenuGroup,
  isNewProductsGroup,
  isProcessableItem,
  orderedSubItems,
  routeForMenuItem,
} from "@/helpers";

export default {
  name: "burger-nav",
  components: {
    VueSlideToggle,
    menuItemLabel,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    isClickableInSidebarMenu: isClickableInSidebarMenu,
    isClickableInDropdown: isClickableInDropdown,
    isMenuGroup: isMenuGroup,
    isNewProductsGroup: isNewProductsGroup,
    isProcessableItem: isProcessableItem,
    orderedSubItems: orderedSubItems,
    /**
     * @param {NavigationItem} navItem
     * @param {NavigationItem|null} parentNavItem
     * @return {Object}
     */
    routeForMenuItem(navItem, parentNavItem = null) {
      if (navItem.slug === "cosmo-base") {
        return this.$localize({ name: "cosmobase" });
      }
      if (navItem.slug === "before-after") {
        return this.$localize({ name: "before-after" });
      }
      if (navItem.slug === "forum") {
        return this.$localize({ name: "ProAge" });
      }
      if (navItem.slug === "promotions") {
        return this.$localize({ name: "promotions" });
      }
      // outlet — окрема сторінка /outlet (Category на беку, не Collection).
      // У /v1/menus приходить як single_page_menu_item, тому форсимо /outlet.
      if (navItem.slug === "outlet") {
        return this.$localize({ name: "outlet" });
      }
      return this.$localize(routeForMenuItem(navItem, parentNavItem));
    },
  },
};
